import { Component, Input, OnInit } from '@angular/core';
// Forms
import { FormGroupDirective, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-legal-representative',
  templateUrl: './legal-representative.component.html',
  styleUrls: ['./legal-representative.component.scss'],
})

export class LegalRepresentativeComponent  implements OnInit {

  /**
   * Variables
   */
  OperatorForm: FormGroup;
  useSameAddress: boolean = false;

  /**
   * Input parameters
   */
  @Input() isSubOperator: boolean = false;
  @Input() isCompany: boolean = false;

  constructor(private rootFormGroup: FormGroupDirective) { }

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the operator form.
   */
  ngOnInit() {
    this.OperatorForm = this.rootFormGroup.control;

    if (!this.isCompany &&
        this.OperatorForm.get('companyIdentification.address.street').value == this.OperatorForm.get('legalRepresentative.address.street').value &&
        this.OperatorForm.get('companyIdentification.address.municipality').value == this.OperatorForm.get('legalRepresentative.address.municipality').value &&
        this.OperatorForm.get('companyIdentification.address.postalCode').value == this.OperatorForm.get('legalRepresentative.address.postalCode').value &&
        this.OperatorForm.get('companyIdentification.address.country').value == this.OperatorForm.get('legalRepresentative.address.country').value &&
        this.OperatorForm.get('companyIdentification.address.region').value == this.OperatorForm.get('legalRepresentative.address.region').value &&
        this.OperatorForm.get('companyIdentification.address.country').value == this.OperatorForm.get('legalRepresentative.address.country').value) {
      this.useSameAddress = true;
    }
  }

  // #endregion --> LifeCycle

  // #region --> Methods

  toggleSameAddress() {
    this.useSameAddress = !this.useSameAddress;

    if (this.useSameAddress) {
      this.OperatorForm.get('legalRepresentative.address').patchValue(this.OperatorForm.get('companyIdentification.address').value);
    } else {
      this.OperatorForm.get('legalRepresentative.address').reset();
    }

  }

  // #endregion --> Methods

}
